import oktaClient from "./oktaClient";
import * as _ from "lodash";
const token = oktaClient.getToken();

export const getAuthGroups = {
  asString: (): string => {
    return token
      ? process.env.REACT_APP_ENV === "PRODUCTION"
        ? JSON.stringify(token.claims.groups)
        : localStorage.getItem("devAuth")
          ? localStorage.getItem("devAuth")
          : JSON.stringify(token.claims.groups)
      : "{}";
  },
  asArray: (): string[] => {
    return token
      ? _.isEmpty(JSON.parse(getAuthGroups.asString()))
        ? []
        : JSON.parse(getAuthGroups.asString())
      : [];
  }
};

export const getUserGroups = (): string => {
  return (process.env.REACT_APP_ENV === "PRODUCTION"
    ? token.claims.groups
    : localStorage.getItem("devAuth")
      ? JSON.parse(localStorage.getItem("devAuth"))
      : token.claims.groups
  )
    .filter(group => group.substring(0, 4) === "Data")
    .join()
    .replace(/Data\//g, "")
    .toLowerCase();
};

export const groupAuth = {
  hasAccessGroup: (requiredGroups: string[]): boolean => {
    return token
      ? getAuthGroups
          .asArray()
          .some(authGroup => requiredGroups.includes(authGroup))
      : false;
  },
  hasAllDataGroups: (requiredGroups: string[]): boolean => {
    return token
      ? requiredGroups.every(requirement =>
          getAuthGroups.asArray().includes(requirement)
        )
      : false;
  }
};
